































































import Vue from 'vue'
import Component from 'vue-class-component'
import DisplaySkills from '@app/componentlib/src/views/components/DisplaySkills.vue'
import { AppModule } from '@app/componentlib/src/store/modules/app'
import { ga } from '@app/componentlib/src/application/analytics'
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'
import InfoToolTip from '@app/componentlib/src/views/components/InfoToolTip.vue'

@Component<CvAdjustCompetences>({
  props: {
    items: Object,
    competencesLink: String,
    validCompetences: Object
  },
  components: {
    DisplaySkills,
    VPopover,
    InfoToolTip
  },
  directives: {
    VTooltip,
    VClosePopover
  }
})

export default class CvAdjustCompetences extends Vue {
  /**
   * Props variables
   */
  items: object[] | undefined
  competencesLink: string | undefined
  validCompetences: string[] | undefined


  /**
   * Component state variables
   */


  /**
   * Lifecycle
   */


  /**
   * Getters
   */
  get t () {
    return AppModule.translations
  }
  get profileLink (): string | undefined {
    return AppModule.portalSettings.profileLink + '#competences'
  }

  /**
   * Methods
   */
  toggleItem (item: object) {
    console.log('toggleItem', item)
  }

  goToProfile () {
    ga.event({
      action: 'Go to profile - header',
      category: 'CV Tool',
      label: 'Competences - header'
    })
  }
}
